import { useMemo } from 'react';
import { usePracticeOptions } from '../../../hooks/useBilling';
import { useUser } from '../../../providers/UserProvider';
import type { AssigneeFilterPerson } from '../../../utils/assigneeFilter';
import { practiceNamesLoaded, type SharedFilterSources } from './listFilterSummary';

interface SharedListParams {
    search: string;
    assignees: string[];
    practiceIds: string[];
}

// What the shared filter lines need to resolve URL values; practices only load when the URL filters by one.
export function useSharedFilterSources(
    { search, assignees, practiceIds }: SharedListParams,
    people: readonly AssigneeFilterPerson[]
): SharedFilterSources {
    const { user } = useUser();
    const { practices, isLoading, isError } = usePracticeOptions(practiceIds.length > 0);
    const currentUserEmail = user?.email;
    return useMemo(
        () => ({
            search,
            assignees: { values: assignees, people, currentUserEmail },
            practices: {
                ids: practiceIds,
                practices,
                loaded: practiceNamesLoaded({ isLoading, isError })
            }
        }),
        [search, assignees, people, currentUserEmail, practiceIds, practices, isLoading, isError]
    );
}
